import React, { useEffect, useState } from 'react';
import { Snackbar, Box } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import WifiOffIcon from '@material-ui/icons/WifiOff';

const useStyles = makeStyles((theme) => ({
  snackbar: {
    bottom: 20,
  },
  alert: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const OfflineNotification = () => {
  const classes = useStyles();
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <Snackbar
      open={!isOnline}
      autoHideDuration={null}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      className={classes.snackbar}
    >
      <Alert
        severity="error"
        variant="filled"
        className={classes.alert}
        icon={
          <Box className={classes.iconContainer}>
            <WifiOffIcon />
          </Box>
        }
      >
        No hay conexión a internet. Por favor, verifica tu conexión.
      </Alert>
    </Snackbar>
  );
};

export default OfflineNotification;
